module.exports = __webpack_public_path__ + "static/media/gps-vehicle-tracking-devices-teltonika-fm1120-8.b2fcf794.png";